<template>
  <div id="app">
    <keep-alive>
      <!-- 如果当前打开页面的路由中 keepAlive: true （开启了缓存时） -->
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <!-- 如果当前打开页面的路由中 没有 或者为 keepAlive: false （关闭缓存时[默认就是false]） -->
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  methods: {
    bodyScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      document.cookie = `scroll=${scrollTop}`;
    },
    scrollback() {
      const scroll = this.GetCookie("scroll");
      if (scroll != null) {
        document.body.scrollTop = scroll;
      }
    },
    GetCookie(sName) {
      const aCookie = document.cookie.split(";");
      // console.log(aCookie);
      for (let i = 0; i < aCookie.length; i++) {
        const aCrumb = aCookie[i].split("=");
        if (sName == aCrumb[0]) {
          return aCrumb[1];
        }
      }
      return null;
    },
  },
  mounted() {
    // this.$i18n.locale='en'
    this.$nextTick(() => {
      window.addEventListener("scroll", this.bodyScroll, true);
      window.addEventListener("load", this.scrollback, true);
    });
  },
};
</script>
<style lang="less">
html,
body {
  /* background-color: #00101F; */
  color: #fff;
  
  padding: 0;
  // overflow-x: hidden;
  // min-width: 960px;
  margin: 0 auto;
 
}
// ::-webkit-scrollbar {
//   width: 1px;

//   background-color: #fff;
// }

// /*滚动条*/

// ::-webkit-scrollbar-thumb {
//   background-color: rgba(255, 232, 253, 0.5);
// }

// /*滚动条外层轨道*/

// ::-webkit-scrollbar-track {
//   -webkit-box-shadow: inset 0 0 1px;

//   background-color: #fff;

//   border-radius: 10px;
// }
</style>
